import { Tooltip } from '@chakra-ui/react';


const CustomTooltip = ({ children, label, ...rest }) => {
  return (
    <Tooltip
      label={label}
      placement="top"
      bg="blue.600"
      color="white"
      hasArrow
      fontSize="sm"
      rounded="sm"
      p={2}
      {...rest}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
